import React, { useEffect, useState, useCallback } from 'react'
import '../styles/Basket.css'

const bankOfGeorgia = `${window.location.origin}/bog-logo.svg`
const BASE_URL = 'https://api.yourhood.ge'

const DELIVERY_OPTIONS = [
  { id: 'tbilisi', label: 'მიწოდება თბილისში',       price: 6,  type: 0 },
  { id: 'city',    label: 'მიწოდება სხვა ქალაქებში', price: 8,  type: 1 },
  { id: 'region',  label: 'მიწოდება რეგიონებში',     price: 13, type: 2 },
]

export default function Basket({ cartItems = [], setCartItems }) {
  const [productDetails, setProductDetails] = useState({})
  const [showForm, setShowForm]             = useState(false)
  const [formData, setFormData]             = useState({ fullName: '', phone: '', address: '', bodyInfo: '' })
  const [formErrors, setFormErrors]         = useState({})
  const [itemErrors, setItemErrors]         = useState({})
  const [loading, setLoading]               = useState(false)
  const [apiError, setApiError]             = useState('')
  const [delivery, setDelivery]             = useState(null)

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  useEffect(() => {
    cartItems.forEach(item => {
      if (productDetails[item.id]) return
      fetch(`${BASE_URL}/api/Product/protudct-details?ProductID=${item.id}`, {
        headers: { 'X-Language': 'ka' }
      })
        .then(res => res.json())
        .then(data => {
          setProductDetails(prev => ({
            ...prev,
            [item.id]: {
              availableSizes: data.availableSizes || [],
              colors: data.colors || [],
            }
          }))
        })
        .catch(() => {})
    })
  }, [cartItems])

  const updateQty = (id, delta) => {
    setCartItems(prev =>
      prev.map(item => item.id === id ? { ...item, quantity: item.quantity + delta } : item)
        .filter(item => item.quantity > 0)
    )
  }

  const removeItem = (id) => {
    setCartItems(prev => prev.filter(item => item.id !== id))
    setItemErrors(prev => { const n = { ...prev }; delete n[id]; return n })
  }

  const updateItemOption = (id, field, value) => {
    setCartItems(prev => prev.map(item => item.id === id ? { ...item, [field]: value } : item))
    setItemErrors(prev => {
      if (!prev[id]) return prev
      const updated = { ...prev[id], [field]: '' }
      if (!updated.size && !updated.color) { const n = { ...prev }; delete n[id]; return n }
      return { ...prev, [id]: updated }
    })
  }

  const subtotal      = cartItems.reduce((sum, item) => sum + item.price * item.quantity, 0)
  const deliveryPrice = delivery ? (DELIVERY_OPTIONS.find(o => o.id === delivery)?.price ?? 0) : 0
  const total         = subtotal + deliveryPrice

  const handleFormChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    setFormErrors(prev => ({ ...prev, [name]: '' }))
    setApiError('')
  }

  const validateItems = () => {
    const errors = {}
    cartItems.forEach(item => {
      const details = productDetails[item.id]
      const itemErr = {}
      if (details?.availableSizes?.length > 0 && !item.size)  itemErr.size  = 'აირჩიეთ ზომა'
      if (details?.colors?.length > 0        && !item.color)  itemErr.color = 'აირჩიეთ ფერი'
      if (Object.keys(itemErr).length > 0) errors[item.id] = itemErr
    })
    return errors
  }

  const validate = () => {
    const errors = {}
    if (!formData.fullName.trim()) errors.fullName = 'სახელი და გვარი სავალდებულოა'
    if (!formData.phone.trim())    errors.phone    = 'ტელეფონი სავალდებულოა'
    if (!formData.address.trim())  errors.address  = 'მისამართი სავალდებულოა'
    if (!delivery)                 errors.delivery = 'მიწოდების ტიპი სავალდებულოა'
    return errors
  }

  const handleBogPayment = async () => {
    if (!showForm) {
      const iErrors = validateItems()
      if (Object.keys(iErrors).length > 0) { setItemErrors(iErrors); return }
      setShowForm(true)
      return
    }

    const iErrors = validateItems()
    const fErrors = validate()
    if (Object.keys(iErrors).length > 0) { setItemErrors(iErrors); return }
    if (Object.keys(fErrors).length > 0) { setFormErrors(fErrors); return }

    setLoading(true)
    setApiError('')

    try {
      const response = await fetch(`${BASE_URL}/Payment/BOG/proceed-payment`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Language': 'ka', 'accept': '*/*' },
        body: JSON.stringify({
          fullName: formData.fullName,
          phone: formData.phone,
          address: formData.address,
          comment: formData.bodyInfo || ' ',
          deliveryType: DELIVERY_OPTIONS.find(o => o.id === delivery)?.type ?? 0,
          items: cartItems.map(item => ({
            productID: item.id,
            quantity: item.quantity,
            size: item.size || '',
            color: item.color || '',
          })),
        }),
      })

      const data = await response.json()
      if (!response.ok) throw new Error(data.message || 'გადახდა ვერ მოხერხდა')
      const redirectUrl = data?._links?.redirect?.href
      if (redirectUrl) window.location.href = redirectUrl
    } catch (err) {
      setApiError(err.message || 'დაფიქსირდა შეცდომა. სცადეთ თავიდან.')
    } finally {
      setLoading(false)
    }
  }

  const handleInstallment = useCallback(() => {
    if (!showForm) {
      const iErrors = validateItems()
      if (Object.keys(iErrors).length > 0) { setItemErrors(iErrors); return }
      setShowForm(true)
      return
    }

    const iErrors = validateItems()
    const fErrors = validate()
    if (Object.keys(iErrors).length > 0) { setItemErrors(iErrors); return }
    if (Object.keys(fErrors).length > 0) { setFormErrors(fErrors); return }

    if (!window.BOG?.Calculator) {
      setApiError('განვადების სერვისი ვერ ჩაიტვირთა. გადატვირთეთ გვერდი.')
      return
    }

    setApiError('')

    window.BOG.Calculator.open({
      amount: total,
      onClose: () => {},
      onRequest: (selected, successCb, closeCb) => {
        console.log('BOG installment selected:', selected)
        fetch(`${BASE_URL}/Payment/BOG/proceed-installment`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Language': 'ka', 'accept': '*/*' },
          body: JSON.stringify({
            fullName: formData.fullName,
            phone: formData.phone,
            address: formData.address,
            comment: formData.bodyInfo || ' ',
            month: selected.month,
            installmenttype: selected.discount_code,
            deliveryType: DELIVERY_OPTIONS.find(o => o.id === delivery)?.type ?? 0,
            items: cartItems.map(item => ({
              productID: item.id,
              quantity: item.quantity,
              size: item.size || '',
              color: item.color || '',
            })),
          }),
        })
          .then(res => res.json())
          .then(data => {
            console.log('BOG installment response:', data)
            if (data.order_id) {
              successCb(data.order_id)
            } else {
              closeCb()
              setApiError(data.message || 'განვადება ვერ მოხერხდა')
            }
          })
          .catch(() => {
            closeCb()
            setApiError('დაფიქსირდა შეცდომა. სცადეთ თავიდან.')
          })
      },
      onComplete: ({ redirectUrl }) => {
        if (redirectUrl) window.location.href = redirectUrl
      },
    })
  }, [total, showForm, formData, cartItems, delivery])

  return (
    <div className="bk-page">
      <div className="bk-header">
        <nav className="bk-breadcrumb">
          <span>მთავარი</span>
          <span className="bk-sep">—</span>
          <span className="bk-sep-active">კალათა</span>
        </nav>
        <h1 className="bk-title">თქვენი კალათა</h1>
        <span className="bk-count">{cartItems.reduce((s, i) => s + i.quantity, 0)} ნივთი</span>
      </div>

      <div className="bk-body">
        <div className="bk-items">
          {cartItems.length === 0 ? (
            <div className="bk-empty">
              <span className="bk-empty-icon">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                  <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
                  <line x1="3" y1="6" x2="21" y2="6"/>
                  <path d="M16 10a4 4 0 01-8 0"/>
                </svg>
              </span>
              <p className="bk-empty-text">კალათა ცარიელია</p>
              <a href="/" className="bk-empty-link">შოპინგის გაგრძელება</a>
            </div>
          ) : (
            cartItems.map((item, index) => {
              const details = productDetails[item.id]
              const sizes   = details?.availableSizes || []
              const colors  = details?.colors || []

              return (
                <div key={item.id} className={`bk-item ${itemErrors[item.id] ? 'bk-item--error' : ''}`} style={{ animationDelay: `${index * 0.08}s` }}>
                  <div className="bk-item-image">
                    <img src={item.image} alt={item.name} />
                  </div>
                  <div className="bk-item-details">
                    <div className="bk-item-top">
                      <div>
                        <span className="bk-item-category">{item.category}</span>
                        <h3 className="bk-item-name">{item.name}</h3>
                      </div>
                      <button className="bk-remove" onClick={() => removeItem(item.id)} title="წაშლა">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                          <line x1="18" y1="6" x2="6" y2="18"/>
                          <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                      </button>
                    </div>

                    {sizes.length > 0 && (
                      <div className="bk-item-picker">
                        <span className={`bk-picker-label ${itemErrors[item.id]?.size ? 'bk-picker-label--error' : ''}`}>
                          ზომა {itemErrors[item.id]?.size && <span className="bk-picker-error">— {itemErrors[item.id].size}</span>}
                        </span>
                        <div className="bk-picker-options">
                          {sizes.map(s => (
                            <button
                              key={s}
                              className={`bk-picker-btn ${item.size === s ? 'bk-picker-btn--active' : ''} ${itemErrors[item.id]?.size ? 'bk-picker-btn--err' : ''}`}
                              onClick={() => updateItemOption(item.id, 'size', s)}
                            >{s}</button>
                          ))}
                        </div>
                      </div>
                    )}

                    {colors.length > 0 && (
                      <div className="bk-item-picker">
                        <span className={`bk-picker-label ${itemErrors[item.id]?.color ? 'bk-picker-label--error' : ''}`}>
                          ფერი {itemErrors[item.id]?.color && <span className="bk-picker-error">— {itemErrors[item.id].color}</span>}
                        </span>
                        <div className="bk-picker-options">
                          {colors.map(c => (
                            <button
                              key={c}
                              className={`bk-picker-btn ${item.color === c ? 'bk-picker-btn--active' : ''} ${itemErrors[item.id]?.color ? 'bk-picker-btn--err' : ''}`}
                              onClick={() => updateItemOption(item.id, 'color', c)}
                            >{c}</button>
                          ))}
                        </div>
                      </div>
                    )}

                    <div className="bk-item-bottom">
                      <div className="bk-qty">
                        <button className="bk-qty-btn" onClick={() => updateQty(item.id, -1)}>−</button>
                        <span className="bk-qty-val">{item.quantity}</span>
                        <button className="bk-qty-btn" onClick={() => updateQty(item.id, +1)}>+</button>
                      </div>
                      <div className="bk-item-price-wrap">
                        {item.originalPrice > item.price && (
                          <span className="bk-item-original">₾{item.originalPrice * item.quantity}</span>
                        )}
                        <span className="bk-item-price">₾{item.price * item.quantity}</span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })
          )}
        </div>

        <div className="bk-summary">
          <h2 className="bk-summary-title">შეკვეთის შეჯამება</h2>
          <div className="bk-summary-rows">
            <div className="bk-summary-row">
              <span>პროდუქტები</span>
              <span>₾{subtotal}</span>
            </div>
            {delivery && (
              <div className="bk-summary-row">
                <span>მიწოდება</span>
                <span>₾{deliveryPrice}</span>
              </div>
            )}
          </div>
          <div className="bk-divider" />
          <div className="bk-summary-row bk-total-row">
            <span>სულ გადასახდელი</span>
            <span>₾{total}</span>
          </div>

          {showForm && (
            <div className="bk-checkout-form">
              <div className="bk-form-field">
                <label className="bk-form-label">სახელი და გვარი</label>
                <input className={`bk-form-input ${formErrors.fullName ? 'bk-form-input--error' : ''}`} type="text" name="fullName" value={formData.fullName} onChange={handleFormChange} />
                {formErrors.fullName && <span className="bk-form-error">{formErrors.fullName}</span>}
              </div>
              <div className="bk-form-field">
                <label className="bk-form-label">ტელეფონი</label>
                <input className={`bk-form-input ${formErrors.phone ? 'bk-form-input--error' : ''}`} type="tel" name="phone" value={formData.phone} onChange={handleFormChange} />
                {formErrors.phone && <span className="bk-form-error">{formErrors.phone}</span>}
              </div>
              <div className="bk-form-field">
                <label className="bk-form-label">მისამართი</label>
                <input className={`bk-form-input ${formErrors.address ? 'bk-form-input--error' : ''}`} type="text" name="address" value={formData.address} onChange={handleFormChange} />
                {formErrors.address && <span className="bk-form-error">{formErrors.address}</span>}
              </div>
              <div className="bk-form-field">
                <label className="bk-form-label">სიმაღლე და წონა <span style={{ fontWeight: 400, opacity: 0.6 }}>(მეტი სიზუსტისთვის)</span></label>
                <input className="bk-form-input" type="text" name="bodyInfo" value={formData.bodyInfo} onChange={handleFormChange} placeholder="მაგ. 170სმ / 65კგ" />
              </div>
              <div className="bk-form-field">
                <label className="bk-form-label">მიწოდება</label>
                <div className="bk-delivery-options">
                  {DELIVERY_OPTIONS.map(opt => (
                    <label key={opt.id} className={`bk-delivery-option ${delivery === opt.id ? 'bk-delivery-option--active' : ''}`} onClick={() => { setDelivery(opt.id); setFormErrors(prev => ({ ...prev, delivery: '' })) }}>
                      <span className={`bk-radio ${delivery === opt.id ? 'bk-radio--checked' : ''}`}>{delivery === opt.id && <span className="bk-radio-dot" />}</span>
                      <span className="bk-delivery-label">{opt.label}</span>
                      <span className="bk-delivery-price">₾{opt.price}</span>
                    </label>
                  ))}
                </div>
                {formErrors.delivery && <span className="bk-form-error">{formErrors.delivery}</span>}
              </div>
              {apiError && <div className="bk-api-error">{apiError}</div>}
            </div>
          )}

          <div className="bk-payment-buttons">
            <button className="bk-bog-btn" onClick={handleBogPayment} disabled={loading || cartItems.length === 0}>
              {loading ? <span className="bk-spinner" /> : (
                <>
                  <img src={bankOfGeorgia} alt="საქართველოს ბანკი" className="bk-bog-logo" />
                  <span>{showForm ? 'გადახდა' : 'საქართველოს ბანკი'}</span>
                </>
              )}
            </button>

         <button className="bk-bog-installment-btn" onClick={handleInstallment} disabled={loading || cartItems.length === 0}>
  <img src={bankOfGeorgia} alt="საქართველოს ბანკი" className="bk-bog-logo" />
  <span>{showForm ? 'განვადება' : 'განვადება'}</span>
</button>

            <button className="bk-tbc-btn" onClick={handleBogPayment} disabled={loading || cartItems.length === 0}>
              {loading ? <span className="bk-spinner bk-spinner--white" /> : (
                <span>ტოპ | <span style={{ fontWeight: 500 }}>ქარდი</span></span>
              )}
            </button>
          </div>

          <a href="/" className="bk-continue">← შოპინგის გაგრძელება</a>
        </div>
      </div>
    </div>
  )
}